import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { useMedia } from 'react-media-match';
import { Image } from '@empiriecom/module-components/Image';
import getIcon from '@empiriecom/module-components/utils/getIcon';
import { Attribute, AttributeValueObject } from '@/src/interfaces';

const SampleOrderWrapper = styled.a<{ mobile: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: ${({ mobile }) => (mobile ? '1rem 0.75rem 0;' : '1rem 0;')};
`;

const SampleOrderIcon = styled(Image)`
  && {
    width: 1.25rem;
    height: auto;
    margin-right: 0.75rem;
  }
`;

const ArrowWrapper = styled.div`
  margin-left: 0.75rem;
`;

export type SampleOrderProps = Pick<Attribute, 'values'>;

/**
 * This is the sample order component. If the current product has a sample order available this
 * component renders the sample order link accordingly.
 */
export const SampleOrder: FunctionComponent<SampleOrderProps> = ({ values }): ReactElement => {
  const { link, text, iconUrl } = values[0] as AttributeValueObject;
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  const ArrowRight = getIcon('ArrowMediumRight');
  return values !== null ? (
    <SampleOrderWrapper data-testid="sample-order" href={link} mobile={isMobile}>
      <SampleOrderIcon src={iconUrl} alt={text} fallback={() => null} />
      {text}
      <ArrowWrapper>
        <ArrowRight />
      </ArrowWrapper>
    </SampleOrderWrapper>
  ) : null;
};

export default SampleOrder;
